export const PREMIUM_PRODUCT_KEYS = {
  seaWolfSimulation: 'sea_wolf_simulation',
  redRockSimulation: 'red_rock_simulation',
  caseySimulation: 'casey_simulation',
  mckinseyAICoach: 'mckinsey_ai_coach',
  bcgAICoach: 'bcg_ai_coach',
};

export const PREMIUM_PRODUCTS = {
  [PREMIUM_PRODUCT_KEYS.seaWolfSimulation]: {
    key: PREMIUM_PRODUCT_KEYS.seaWolfSimulation,
    entitlement: 'sea_wolf_simulation',
    displayName: 'Sea Wolf Simulation',
    signInTitle: 'Sign in to launch Sea Wolf',
    signInBody:
      'Sea Wolf demo access stays public. Sign in to launch the full simulator and check whether your plan already includes it.',
    upgradeTitle: 'Unlock the full Sea Wolf Simulation',
    upgradeBody:
      'Sea Wolf is included in Solve Assessment, McKinsey Track (Full), and All-Access.',
    includedIn: 'Included in Solve Assessment, McKinsey Track (Full), and All-Access',
    signInCtaLabel: 'Sign in to continue',
    upgradeCtaLabel: 'View plans',
    pricingHighlight: 'solve_assessment',
    track: 'mck',
    demoLabel: 'See demo',
    demoState: { scrollToLiveDemos: true, track: 'mck', demoVariantMck: 'assessment' },
  },
  [PREMIUM_PRODUCT_KEYS.redRockSimulation]: {
    key: PREMIUM_PRODUCT_KEYS.redRockSimulation,
    entitlement: 'red_rock_simulation',
    displayName: 'Red Rock Simulation',
    signInTitle: 'Sign in to launch Red Rock',
    signInBody:
      'Red Rock demo access stays public. Sign in to launch the full simulator and see whether your current plan already unlocks it.',
    upgradeTitle: 'Unlock the full Red Rock Simulation',
    upgradeBody:
      'Red Rock is included in Solve Assessment, McKinsey Track (Full), and All-Access.',
    includedIn: 'Included in Solve Assessment, McKinsey Track (Full), and All-Access',
    signInCtaLabel: 'Sign in to continue',
    upgradeCtaLabel: 'View plans',
    pricingHighlight: 'solve_assessment',
    track: 'mck',
    demoLabel: 'See demo',
    demoState: { scrollToLiveDemos: true, track: 'mck', demoVariantMck: 'redrock' },
  },
  [PREMIUM_PRODUCT_KEYS.caseySimulation]: {
    key: PREMIUM_PRODUCT_KEYS.caseySimulation,
    entitlement: 'casey_simulation',
    displayName: 'BCG Casey Simulation',
    signInTitle: 'Sign in to launch Casey',
    signInBody:
      'Casey demo access stays public. Sign in to launch the full simulator and check whether your plan already includes it.',
    upgradeTitle: 'Unlock the full BCG Casey Simulation',
    upgradeBody:
      'Casey Simulation is included in Casey Assessment, BCG Track (Full), and All-Access.',
    includedIn: 'Included in Casey Assessment, BCG Track (Full), and All-Access',
    signInCtaLabel: 'Sign in to continue',
    upgradeCtaLabel: 'View plans',
    pricingHighlight: 'casey_assessment',
    track: 'bcg',
    demoLabel: 'See demo',
    demoState: { scrollToLiveDemos: true, track: 'bcg', demoVariantBcg: 'assessment' },
  },
  [PREMIUM_PRODUCT_KEYS.mckinseyAICoach]: {
    key: PREMIUM_PRODUCT_KEYS.mckinseyAICoach,
    entitlement: 'mckinsey_ai_coach',
    displayName: 'McKinsey AI Coach',
    signInTitle: 'Sign in to open the McKinsey AI Coach',
    signInBody:
      'The demo stays public. Sign in to open the full coach and see whether your plan already includes it.',
    upgradeTitle: 'Unlock the full McKinsey AI Coach',
    upgradeBody:
      'The McKinsey AI Coach is included in McKinsey AI Coach Only, McKinsey Track (Full), and All-Access.',
    includedIn: 'Included in McKinsey AI Coach Only, McKinsey Track (Full), and All-Access',
    signInCtaLabel: 'Sign in to continue',
    upgradeCtaLabel: 'View McKinsey plans',
    pricingHighlight: 'mckinsey_ai_coach_only',
    track: 'mck',
    demoLabel: 'See demo',
    demoState: { scrollToLiveDemos: true, track: 'mck', demoVariantMck: 'aiCoach' },
  },
  [PREMIUM_PRODUCT_KEYS.bcgAICoach]: {
    key: PREMIUM_PRODUCT_KEYS.bcgAICoach,
    entitlement: 'bcg_ai_coach',
    displayName: 'BCG AI Coach',
    signInTitle: 'Sign in to open the BCG AI Coach',
    signInBody:
      'The demo stays public. Sign in to open the full coach and see whether your plan already includes it.',
    upgradeTitle: 'Unlock the full BCG AI Coach',
    upgradeBody:
      'The BCG AI Coach is included in BCG AI Coach Only, BCG Track (Full), and All-Access.',
    includedIn: 'Included in BCG AI Coach Only, BCG Track (Full), and All-Access',
    signInCtaLabel: 'Sign in to continue',
    upgradeCtaLabel: 'View BCG plans',
    pricingHighlight: 'bcg_ai_coach_only',
    track: 'bcg',
    demoLabel: 'See demo',
    demoState: { scrollToLiveDemos: true, track: 'bcg', demoVariantBcg: 'aiCoach' },
  },
};

export function getPremiumProduct(productKey) {
  const product = PREMIUM_PRODUCTS[productKey];
  if (!product) {
    throw new Error(`Unknown premium product key: ${productKey}`);
  }
  return product;
}
